import "./two_column_menu_text_block.css";
